// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1A5d0","inputDescription":"styles_inputDescription__1xp9j"};